/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_UitlegInputs */

const nl_planning_rooster_uitleg = /** @type {(inputs: Planning_Rooster_UitlegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor alle docenten van de school. Kies een dag, klik op een vakje en kies de klas en wie de les geeft.`)
};

/**

* @param {Planning_Rooster_UitlegInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_uitleg = /** @type {((inputs?: Planning_Rooster_UitlegInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_UitlegInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_uitleg(inputs)
});
export { planning_rooster_uitleg as "planning.rooster.uitleg" }